import { Shield, AlertTriangle, Heart, FlaskConical, Scale, Users, Clock, CheckCircle, Lock } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { SEO } from "../components/SEO";

export const Terms = () => {
  const { language } = useLanguage();
  const isRTL = language === 'he';

  const sections = isRTL ? [
    {
      icon: Shield,
      title: "הצהרה משפטית כללית",
      content: `המידע המוצג באתר זה, לרבות הפורמולות, ההנחיות והמתכונים, מוצע "כמות שהוא" (AS IS) ללא כל מצג או התחייבות מכל סוג שהוא, במפורש או במשתמע. השימוש במידע הוא באחריותך הבלעדית והמלאה.

בעל האתר, מפתחיו ומפעיליו אינם נושאים באחריות לכל נזק, ישיר או עקיף, שעלול להיגרם כתוצאה משימוש במידע המוצג באתר, לרבות אך לא רק: גירוי עור, תגובות אלרגיות, נזק בריאותי או כל נזק אחר.`
    },
    {
      icon: FlaskConical,
      title: "אופי הפרויקט",
      content: `פרויקט זה הוא ניסוי חברתי וחינוכי שמטרתו לשתף ידע פתוח בנושא קוסמטיקה טבעית. הפרויקט פותח בסיוע בינה מלאכותית (AI) ככלי עזר מחקרי, ולא כסמכות רפואית או קוסמטית מוסמכת.

המוצרים והפורמולות באתר זה הם ניסיוניים ולא עברו בדיקות קליניות, אישורי משרד הבריאות או כל גוף רגולטורי אחר. הפרויקט אינו מיועד למטרות רווח מקסימליות אלא לשיתוף ידע ולמידה קהילתית.`
    },
    {
      icon: AlertTriangle,
      title: "⚠️ אזהרה חשובה - בדיקת רגישות",
      highlight: true,
      content: `לפני שימוש ראשון בכל מוצר, חובה לבצע בדיקת רגישות:

1. מרחו כמות קטנה מאוד על אזור לא רגיש בעור, כגון גב כף היד או חלק פנימי של המרפק
2. המתינו לפחות 48 שעות (יומיים מלאים)
3. בדקו אם מופיעים סימנים כגון: אדמומיות, גירוד, פריחה, נפיחות או כל תגובה חריגה
4. רק אם לא הופיעה כל תגובה - ניתן להמשיך לשימוש זהיר

במקרה של כל תגובה חריגה - הפסיקו שימוש מיידית ופנו לרופא עור.`
    },
    {
      icon: Heart,
      title: "הגבלות שימוש",
      content: `אין להשתמש במוצרים או בפורמולות אם:
• יש לכם רגישות ידועה לאחד מהמרכיבים
• יש לכם מצב עורי קיים (אקזמה, פסוריאזיס, דרמטיטיס וכו')
• אתם בהריון או מניקות - התייעצו עם רופא קודם
• מדובר בילדים מתחת לגיל 12
• יש לכם מערכת חיסון מוחלשת

המוצרים מיועדים לשימוש חיצוני בלבד. אין לבלוע, להשתמש על עור פגוע, ליד עיניים או על ריריות.`
    },
    {
      icon: Scale,
      title: "הגבלת אחריות",
      content: `בשום מקרה לא יהיו בעל האתר, מפתחיו, שותפיו או מי מטעמם אחראים לכל נזק ישיר, עקיף, מקרי, מיוחד, תוצאתי או עונשי, לרבות אך לא רק אובדן רווחים, נתונים, שימוש, מוניטין או הפסדים בלתי מוחשיים אחרים.

הגבלה זו חלה בין אם האחריות מבוססת על חוזה, עוולה (לרבות רשלנות), אחריות קפידה או כל בסיס משפטי אחר, ובין אם הודע לנו על האפשרות של נזקים כאלה ובין אם לאו.`
    },
    {
      icon: Users,
      title: "קהילה ושיתוף ידע",
      content: `תכני המשתמשים באזור הקהילה הם באחריות המשתמשים בלבד. האתר אינו אחראי לדיוק, שלמות או בטיחות של מידע שמשתפים משתמשים אחרים.

כל ניסוי או שינוי בפורמולה שמבוצע על ידי משתמשים הוא באחריותם הבלעדית. מומלץ להתייעץ עם בעל מקצוע מוסמך לפני ביצוע שינויים משמעותיים.`
    },
    {
      icon: Lock,
      title: "מדיניות פרטיות",
      content: `הגנת הפרטיות שלכם חשובה לנו.

כאשר אתם מתחברים לאתר באמצעות חשבון Google, אנו שומרים את המידע הבא בלבד:
• כתובת האימייל שלכם
• השם המוצג שלכם
• תמונת הפרופיל (אם קיימת)

מידע זה נשמר אך ורק לצורך:
• זיהוי הפוסטים והתגובות שלכם בקהילה
• עדכונים עתידיים בנוגע לנוסחה ולקהילה (במידה ותרצו)

איננו:
• מוכרים או משתפים את המידע שלכם עם צדדים שלישיים
• שולחים פרסומות או דואר זבל
• משתמשים במידע למטרות שיווקיות

ניתן לבקש מחיקת החשבון והמידע בכל עת באמצעות פנייה אלינו.

למידע נוסף על הפרויקט ועקרונותיו, קראו את המאמר שלנו בעמוד "מאמר מערכת".`
    },
    {
      icon: Clock,
      title: "תוקף ושינויים",
      content: `תקנון זה עודכן לאחרונה בינואר 2026.

אנו שומרים לעצמנו את הזכות לעדכן תקנון זה מעת לעת. המשך השימוש באתר לאחר עדכון התקנון מהווה הסכמה לתנאים המעודכנים.

השימוש באתר מהווה הסכמה מלאה לכל התנאים המפורטים בתקנון זה.`
    }
  ] : [
    {
      icon: Shield,
      title: "General Legal Disclaimer",
      content: `The information presented on this website, including formulas, guidelines, and recipes, is offered "AS IS" without any representation or warranty of any kind, express or implied. Use of this information is at your sole and complete responsibility.

The website owner, developers, and operators are not liable for any damage, direct or indirect, that may result from using the information presented on the site, including but not limited to: skin irritation, allergic reactions, health damage, or any other damage.`
    },
    {
      icon: FlaskConical,
      title: "Nature of the Project",
      content: `This project is a social and educational experiment aimed at sharing open knowledge about natural cosmetics. The project was developed with the assistance of artificial intelligence (AI) as a research aid, not as a certified medical or cosmetic authority.

The products and formulas on this site are experimental and have not undergone clinical testing, Ministry of Health approvals, or any other regulatory body. The project is not intended for maximum profit but for knowledge sharing and community learning.`
    },
    {
      icon: AlertTriangle,
      title: "⚠️ Important Warning - Sensitivity Test",
      highlight: true,
      content: `Before first use of any product, a sensitivity test is mandatory:

1. Apply a very small amount to a non-sensitive area of skin, such as the back of the hand or inner elbow
2. Wait at least 48 hours (two full days)
3. Check for signs such as: redness, itching, rash, swelling, or any unusual reaction
4. Only if no reaction occurred - proceed with careful use

In case of any unusual reaction - stop use immediately and consult a dermatologist.`
    },
    {
      icon: Heart,
      title: "Usage Restrictions",
      content: `Do not use the products or formulas if:
• You have a known sensitivity to any of the ingredients
• You have an existing skin condition (eczema, psoriasis, dermatitis, etc.)
• You are pregnant or breastfeeding - consult a doctor first
• For children under 12 years old
• You have a compromised immune system

Products are for external use only. Do not ingest, use on damaged skin, near eyes, or on mucous membranes.`
    },
    {
      icon: Scale,
      title: "Limitation of Liability",
      content: `In no event shall the website owner, developers, partners, or their representatives be liable for any direct, indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, use, goodwill, or other intangible losses.

This limitation applies whether the liability is based on contract, tort (including negligence), strict liability, or any other legal basis, and whether or not we were advised of the possibility of such damages.`
    },
    {
      icon: Users,
      title: "Community and Knowledge Sharing",
      content: `User content in the community area is the sole responsibility of the users. The site is not responsible for the accuracy, completeness, or safety of information shared by other users.

Any experiment or modification to the formula performed by users is at their sole responsibility. It is recommended to consult a qualified professional before making significant changes.`
    },
    {
      icon: Lock,
      title: "Privacy Policy",
      content: `Your privacy is important to us.

When you sign in to the site using your Google account, we store only the following information:
• Your email address
• Your display name
• Your profile picture (if available)

This information is stored solely for:
• Identifying your posts and comments in the community
• Future updates regarding the formula and community (if you wish)

We do NOT:
• Sell or share your information with third parties
• Send advertisements or spam
• Use your information for marketing purposes

You can request deletion of your account and data at any time by contacting us.

For more information about the project and its principles, read our article on the "Editorial" page.`
    },
    {
      icon: Clock,
      title: "Validity and Changes",
      content: `These terms were last updated in January 2026.

We reserve the right to update these terms from time to time. Continued use of the site after updating the terms constitutes agreement to the updated terms.

Use of the site constitutes full agreement to all terms set forth in these terms.`
    }
  ];

  return (
    <div className="min-h-screen pt-20 pb-12" dir={isRTL ? 'rtl' : 'ltr'}>
      <SEO page="terms" />
      {/* Header */}
      <section className="px-4 sm:px-6 mb-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-14 h-14 bg-gradient-to-br from-[#4A5D43] to-[#3A4A35] rounded-2xl flex items-center justify-center mx-auto mb-3 shadow-lg">
            <Shield className="w-7 h-7 text-white" />
          </div>
          <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium text-[#2C3329] mb-3">
            {isRTL ? 'תקנון ואחריות משפטית' : 'Terms & Legal Disclaimer'}
          </h1>
          <p className="text-[#6B7266] max-w-2xl mx-auto">
            {isRTL 
              ? 'קראו בעיון את התנאים הבאים לפני השימוש באתר ובמוצרים'
              : 'Please read the following terms carefully before using the site and products'}
          </p>
        </div>
      </section>

      {/* Important Notice Banner */}
      <section className="px-4 sm:px-6 mb-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-[#C47F64] to-[#A66B52] rounded-2xl p-6 text-white">
            <div className={`flex items-start gap-4 ${isRTL ? 'flex-row' : 'flex-row'}`}>
              <AlertTriangle className="w-8 h-8 shrink-0 mt-1" />
              <div className={`text-${isRTL ? 'right' : 'left'}`}>
                <h2 className="font-serif text-xl mb-2">
                  {isRTL ? 'שימו לב!' : 'Please Note!'}
                </h2>
                <p className="text-white/90">
                  {isRTL 
                    ? 'מוצרים אלו הם ניסיוניים ומבוססים על חומרים טבעיים. אין זה מוצר רפואי או קוסמטי מאושר. השימוש הוא באחריותכם בלבד. תמיד בצעו בדיקת רגישות לפני שימוש ראשון.'
                    : 'These products are experimental and based on natural materials. This is not an approved medical or cosmetic product. Use is at your own responsibility. Always perform a sensitivity test before first use.'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sections */}
      <section className="px-4 sm:px-6">
        <div className="max-w-4xl mx-auto space-y-4">
          {sections.map((section, index) => {
            const Icon = section.icon;
            return (
              <div 
                key={index}
                className={`premium-card rounded-2xl p-6 sm:p-8 ${
                  section.highlight 
                    ? 'bg-gradient-to-br from-[#FFF8F5] to-[#FFF0EB] border-2 border-[#C47F64]/30' 
                    : ''
                }`}
              >
                <div className={`flex items-start gap-4 mb-4 ${isRTL ? 'flex-row' : 'flex-row'}`}>
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${
                    section.highlight 
                      ? 'bg-[#C47F64]/20 text-[#C47F64]' 
                      : 'bg-[#4A5D43]/10 text-[#4A5D43]'
                  }`}>
                    <Icon className="w-6 h-6" />
                  </div>
                  <h2 className={`font-serif text-xl sm:text-2xl ${
                    section.highlight ? 'text-[#C47F64]' : 'text-[#2C3329]'
                  }`}>
                    {section.title}
                  </h2>
                </div>
                <div className={`text-[#6B7266] whitespace-pre-line leading-relaxed ${isRTL ? 'text-right' : 'text-left'}`}>
                  {section.content}
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Quick Test Reminder */}
      <section className="px-4 sm:px-6 mt-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-[#4A5D43] rounded-2xl p-5 sm:p-6 text-white">
            <h3 className={`font-serif text-lg mb-3 flex items-center gap-2 ${isRTL ? 'flex-row' : 'flex-row'}`}>
              <CheckCircle className="w-6 h-6" />
              {isRTL ? 'תזכורת: בדיקת רגישות' : 'Reminder: Sensitivity Test'}
            </h3>
            <div className={`grid grid-cols-1 sm:grid-cols-4 gap-4 text-center ${isRTL ? 'sm:direction-rtl' : ''}`}>
              <div className="bg-white/10 rounded-xl p-4">
                <div className="text-3xl mb-2">🖐️</div>
                <p className="text-sm">{isRTL ? 'מרחו על גב כף היד' : 'Apply to back of hand'}</p>
              </div>
              <div className="bg-white/10 rounded-xl p-4">
                <div className="text-3xl mb-2">⏰</div>
                <p className="text-sm">{isRTL ? 'המתינו 48 שעות' : 'Wait 48 hours'}</p>
              </div>
              <div className="bg-white/10 rounded-xl p-4">
                <div className="text-3xl mb-2">👀</div>
                <p className="text-sm">{isRTL ? 'בדקו תגובות' : 'Check for reactions'}</p>
              </div>
              <div className="bg-white/10 rounded-xl p-4">
                <div className="text-3xl mb-2">✅</div>
                <p className="text-sm">{isRTL ? 'רק אז - המשיכו' : 'Only then - proceed'}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Acceptance */}
      <section className="px-4 sm:px-6 mt-6">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-sm text-[#9A9790]">
            {isRTL 
              ? 'השימוש באתר ובמוצרים מהווה הסכמה לכל התנאים המפורטים לעיל'
              : 'Use of the site and products constitutes agreement to all terms detailed above'}
          </p>
          <p className="text-xs text-[#9A9790] mt-2">
            {isRTL ? 'עודכן לאחרונה: ינואר 2026' : 'Last updated: January 2026'}
          </p>
        </div>
      </section>
    </div>
  );
};

export default Terms;
